import {
    LayoutSvgBody,
    LayoutSvgWrapper,
    LayoutSvgDesc,
    SvgChart, SvgSpot, SvgSpotItem,
    EditIcon, DeleteIcon, LayoutSettingIconWrapper,
    LayoutItemBody, CustomSpotItem
} from "../../styles/dashboard";
import Text from "../../utils/Text";
import {useState} from "react";
import {useLayoutContext} from "../../contexts/layout";
import {AddIcon} from "../../styles/InvoiceStyles";
import {Flex, CFlex} from "../../styles/MarketStyles";
import {useNavigate} from "react-router-dom";


const AvailableLayoutItem = (props) => {

    const {
        layout,
        active,
        type,
        index
    } = props

    const navigate = useNavigate()
    const [hover, setHover] = useState(false)
    const { setActiveLayout, deleteLayout } = useLayoutContext()

    const onLayoutClicked = () => {
        if (type === 'create') navigate('/edit')
        else setActiveLayout(layout)
    }

    const onEditLayout = () => {
        navigate(`/edit?layout=${layout}&mode=edit`)
    }

    const isCustom =
        layout !== 'fullscreen' &&
        layout !== 'classic' &&
        type !== 'create'

    return (
        <LayoutItemBody custom={isCustom}>
            <CFlex
                style={{ cursor: 'pointer' }}
                onClick={onLayoutClicked}
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
            >
                <LayoutSvgWrapper active={active}>
                    <LayoutSvgBody>
                        {layout === 'classic' &&
                            <ClassicSvg />
                        }
                        {layout === 'fullscreen' &&
                            <FullscreenSvg />
                        }
                        {index === 2 &&
                            <FirstCustomSvg />
                        }
                        {index === 3 &&
                            <SecondCustomSvg />
                        }
                        {index === 4 &&
                            <ThirdCustomSvg />
                        }
                        {type === 'create' &&
                            <Flex fw fh>
                                <AddIcon size={16} />
                            </Flex>
                        }
                    </LayoutSvgBody>
                </LayoutSvgWrapper>
                <LayoutSvgDesc active={active} hovered={hover} custom={isCustom}>
                    <Text tid={type === 'create' ? 'add-layout' : layout} />
                </LayoutSvgDesc>
            </CFlex>
            {isCustom &&
                <CFlex>
                    <LayoutSettingIconWrapper
                        onClick={onEditLayout}
                    >
                        <EditIcon size={15} />
                    </LayoutSettingIconWrapper>
                    <LayoutSettingIconWrapper
                        onClick={() => deleteLayout(layout)}
                    >
                        <DeleteIcon size={14} />
                    </LayoutSettingIconWrapper>
                </CFlex>
            }
        </LayoutItemBody>
    )
}

const ClassicSvg = () => {

    return (
        <SvgSpot left={'23px'} bottom={'8px'}>
            <SvgSpotItem type={'buy'} />
            <SvgSpotItem type={'sell'} />
        </SvgSpot>
    )
}

const FullscreenSvg = () => {

    return (
        <>
            <SvgChart left={'4px'} bottom={'20px'} />
            <SvgSpot left={'40px'} bottom={'4px'}>
                <SvgSpotItem type={'buy'} />
                <SvgSpotItem type={'sell'} />
            </SvgSpot>
        </>

    )
}

const FirstCustomSvg = () => {
    return (
        <>
            <CustomSpotItem type={'buy'} top={'6px'} left={'46px'}/>
            <SvgChart left={'24px'} bottom={'12px'} />
            <CustomSpotItem type={'sell'} top={'32px'} left={'8px'}/>
        </>
    )
}

const SecondCustomSvg = () => {
    return (
        <>
            <CustomSpotItem type={'buy'} top={'6px'} left={'8px'}/>
            <SvgChart left={'24px'} bottom={'12px'} />
            <CustomSpotItem type={'sell'} top={'32px'} left={'46px'}/>
        </>
    )
}

const ThirdCustomSvg = () => {

    return (
        <>
            <SvgSpot left={'22px'} bottom={'24px'}>
                <SvgSpotItem type={'buy'} />
                <SvgSpotItem type={'sell'} />
            </SvgSpot>
            <SvgChart left={'23px'} bottom={'6px'} />
        </>
    )
}


export default AvailableLayoutItem
